export default __webpack_public_path__ + "static/skills-tag-parts-dark-ed68a0ff49866f27f9b2cb2a580cceb0.png";